<div class="row mb-2">
  <div class="col-lg-12">
    <div class="card">
      <div class="card-header" (click)="changeFilterOpenState()" style="cursor:pointer">
        <i class="fa fa-filter"></i> Filters
        <div class="pull-right">
          @if (isFilterOpen) {
            <i class="fa fa-chevron-down"></i>
          } @else {
            <i class="fa fa-chevron-left"></i>
          }
        </div>
      </div>
      <div class="card-body" [collapse]="!isFilterOpen">
        <div class="row align-items-center">
          <div class="col-sm-auto d-flex align-items-center gap-2">
            <div class="form-check form-switch mb-0">
              <input class="form-check-input" type="checkbox" id="exitedFilterActive" [(ngModel)]="requestFilters.is_exited_filter_active">
              <label class="form-check-label" for="exitedFilterActive">Filter by exited</label>
            </div>
            @if (requestFilters.is_exited_filter_active) {
              <div class="form-check form-switch mb-0 ms-3">
                <input class="form-check-input" type="checkbox" id="isExited" [(ngModel)]="requestFilters.is_exited">
                <label class="form-check-label" for="isExited">{{ requestFilters.is_exited ? 'Exited' : 'Not exited' }}</label>
              </div>
            }
          </div>
        </div>
        <div class="mt-2">
          <button [disabled]="isLoading" class="btn btn-sm btn-primary me-1" (click)="onClickFilter()"><i class="fa fa-filter"></i> Filter</button>
          <button [disabled]="isLoading" class="btn btn-sm btn-danger" (click)="onClickResetFilters()"><i class="fa fa-ban"></i> Reset</button>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="row mb-2">
  <div class="col-lg-12">
    <div class="card">
      <div class="card-header" (click)="changeStatsOpenState()" style="cursor:pointer">
        <i class="fa fa-bar-chart"></i> Statistics
        <div class="pull-right">
          @if (isStatsOpen) {
            <i class="fa fa-chevron-down"></i>
          } @else {
            <i class="fa fa-chevron-left"></i>
          }
        </div>
      </div>
      <div class="card-body" [collapse]="!isStatsOpen">
        <div class="d-flex gap-4 mb-3">
          <div>
            <small class="text-muted">Total matches</small>
            <div class="fw-bold">{{ totalResults }}</div>
          </div>
          <div>
            <small class="text-muted">Exited matches</small>
            <div class="fw-bold">{{ exitedCount }}</div>
          </div>
        </div>
        @if (chartData.labels && chartData.labels.length > 0) {
          <c-chart type="bar" [data]="chartData" [options]="chartOptions" style="max-height: 300px;"></c-chart>
        } @else {
          <p class="text-muted mb-0">No table statistics available.</p>
        }
      </div>
    </div>
  </div>
</div>

<div class="row">
  <div class="col-lg-12">
    <div class="card">
      <div class="card-header">
        <i class="fa fa-gamepad"></i> Matchs
      </div>
      <div class="card-body">
        <table class="table table-responsive-sm table-hover table-outline mb-0">
          <thead class="thead-light">
            <tr>
              <th>#</th>
              <th>Match ID</th>
              <th>Variant</th>
              <th>Cost</th>
              <th>State</th>
              <th>Start</th>
              <th>End</th>
              <th>Rank</th>
              <th>Score</th>
              <th>Status</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            @for (match of matches; track match.matchId; let i = $index) {
              <tr>
                <td>{{ (pageNumber - 1) * resultsPerPage + i + 1 }}</td>
                <td>
                  <div>{{ match.matchId }}</div>
                  @if (match.matchmakerTicketId) {
                    <small class="text-muted d-block">ticket: {{ match.matchmakerTicketId }}</small>
                  }
                  @if (match.matchmakerPlayerSessionId) {
                    <small class="text-muted d-block">session: {{ match.matchmakerPlayerSessionId }}</small>
                  }
                </td>
                <td>{{ match.matchVariantId }}</td>
                <td>{{ match.matchTableCost }}</td>
                <td>{{ MatchState[match.matchState] }}</td>
                <td>{{ match.matchStartTimestamp !== 0 ? dateService.getDateFromatted(match.matchStartTimestamp) : '-' }}</td>
                <td>{{ match.matchEndTimestamp !== 0 ? dateService.getDateFromatted(match.matchEndTimestamp) : '-' }}</td>
                <td>{{ match.rank }}</td>
                <td>{{ match.score }}</td>
                <td>
                  @if (match.isExited) {
                    <span class="badge bg-danger">Exited</span>
                  }
                </td>
                <td>
                  <button class="btn btn-sm btn-primary" (click)="matchDetailModal.show(userId, match.matchId)">
                    <i class="fa fa-search"></i>
                  </button>
                </td>
              </tr>
            }
          </tbody>
        </table>
        <br/>
        <div class="d-flex justify-content-between align-items-center">
          <small class="text-muted">
            Showing {{ (pageNumber - 1) * resultsPerPage + 1 }} to {{ (pageNumber - 1) * resultsPerPage + matches.length }} of {{ totalResults }} entries
          </small>
          <ul class="pagination pagination-sm mb-0">
            <li class="page-item" [class.disabled]="pageNumber <= 1">
              <button class="page-link" (click)="onClickPaginationPrevious()" [disabled]="pageNumber <= 1">&laquo;</button>
            </li>
            @for (page of getPageNumbers(); track $index) {
              @if (page === null) {
                <li class="page-item disabled"><span class="page-link">...</span></li>
              } @else {
                <li class="page-item" [class.active]="page === pageNumber">
                  <button class="page-link" (click)="goToPage(page)">{{ page }}</button>
                </li>
              }
            }
            <li class="page-item" [class.disabled]="matches.length < resultsPerPage">
              <button class="page-link" (click)="onClickPaginationNext()" [disabled]="matches.length < resultsPerPage">&raquo;</button>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</div>

<app-user-match-detail-modal #matchDetailModal></app-user-match-detail-modal>
